import {YELLOW_SOFT} from '../colors'

export const getWorkflowNoteBlock = (text, x, y) => {
    return {
        model: {
            text: ''
        },
        attrs: {
            width: 120,
            height: 120,
            x,
            y,
            fill: YELLOW_SOFT,
            fontSize: 18
        },
        editableAttrs: {
            fill: {
                label: 'Color',
                type: 'color'
            }
        }
    }
}
